document.addEventListener("DOMContentLoaded", function () {
 let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
 const buttons = document.querySelectorAll(".wishlist-btn");

 function updateButton(btn, active) {
  if (active) {
   btn.classList.add("active");
   btn.setAttribute("aria-pressed", "true");
  } else {
   btn.classList.remove("active");
   btn.setAttribute("aria-pressed", "false");
  }
 }

 // Load initial state
 buttons.forEach((btn) => {
  const handle = btn.dataset.productHandle;
  if (!handle) return;

  if (wishlist.includes(handle)) {
   updateButton(btn, true);
  }

  btn.addEventListener("click", function (e) {
   e.preventDefault(); // Stop the default behavior of the button/link
   const handle = this.dataset.productHandle;
   if (!handle) return;

   if (wishlist.includes(handle)) {
    // Remove
    wishlist = wishlist.filter((item) => item !== handle);
    updateButton(this, false);
   } else {
    // Add
    wishlist.push(handle);
    updateButton(this, true);
   }

   localStorage.setItem("wishlist", JSON.stringify(wishlist));

   // Event trigger (optional: update wishlist page instantly)
   window.dispatchEvent(new CustomEvent("wishlist:updated", {
    detail: { wishlist, productHandle: handle }
   }));
  });
 });
});
